export default () => {
  const examples = [
    [
      [0, 0, 3, 0, 0, 0, 0, 0, 0],
      [5, 8, 0, 2, 0, 0, 3, 0, 9],
      [2, 0, 0, 4, 0, 5, 8, 7, 1],
      [3, 7, 0, 0, 1, 0, 5, 9, 0],
      [8, 0, 0, 7, 4, 0, 1, 3, 0],
      [0, 2, 9, 0, 0, 8, 0, 0, 0],
      [6, 0, 0, 1, 0, 3, 4, 0, 7],
      [4, 0, 2, 0, 6, 0, 0, 0, 0],
      [0, 0, 0, 5, 2, 4, 6, 8, 0],
    ],
    [
      [4, 0, 0, 0, 5, 0, 0, 3, 2],
      [0, 1, 0, 0, 9, 0, 7, 0, 5],
      [7, 5, 3, 0, 0, 4, 1, 9, 6],
      [0, 0, 1, 0, 7, 0, 0, 0, 0],
      [6, 0, 9, 0, 0, 1, 2, 5, 0],
      [0, 0, 0, 5, 0, 0, 6, 1, 3],
      [3, 0, 4, 0, 0, 8, 0, 0, 1],
      [0, 0, 0, 4, 0, 0, 0, 7, 8],
      [0, 0, 0, 7, 6, 3, 0, 2, 9],
    ],
    [
      [0, 0, 4, 2, 7, 6, 0, 3, 0],
      [0, 5, 7, 1, 0, 0, 0, 4, 9],
      [0, 0, 0, 9, 0, 0, 0, 0, 0],
      [3, 0, 0, 0, 0, 0, 9, 6, 0],
      [0, 0, 0, 0, 0, 7, 1, 8, 5],
      [0, 0, 0, 0, 2, 0, 3, 0, 4],
      [0, 0, 0, 7, 0, 1, 0, 9, 0],
      [0, 0, 0, 6, 0, 0, 2, 1, 0],
      [1, 0, 6, 0, 8, 0, 0, 0, 0],
    ],
  ];
  return { examples, pos: Math.floor(Math.random() * examples.length) };
};
